







































import { Component, Vue } from "vue-property-decorator";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AnamnesisPerawat extends Vue {
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  riwayatAlergi = null;
  riwayatObat = null;
  riwayatPenyakitLalu = null;
  riwayatMakanTerakhir = null;
  riwayatLainLain = null;

  saveData() {
    if (this.readOnly) return;
    //
  }
}
